import React from 'react'
import portada from './Comp-3.mp4';


function Portada() {
  return (
      <div>
          <video className='video-portada'
          src={portada}
          loop muted autoPlay controls = ''
          
          />
      </div>
  )
}

export default Portada